import { useState } from "react";
import { Button } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";
import styled from "styled-components";
import { useConfig } from "../../../../../lib/config";
import { StyledSpinner } from "../../../../ariSnapshot/styles";
import { UPDATE_ENTITY_ACTIONS } from "../../../Common/constants";
import { useStripePaymentsApi } from "./StripePaymentsApi";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

interface Props {
  label: string;
  paymentMethod: string;
  propertyTicker: string;
  updateFormValue: ({
    action,
    formValueProperties,
    value,
  }: {
    action: string;
    formValueProperties: string;
    value: string;
  }) => void;
}

const messages = defineMessages({
  error: {
    id: "paymentTypesForm.error.stripeCreateConnectedAccount",
    defaultMessage: "Some error occurred. Try again later",
  },
});

export function CreateConnectedAccountBtn({
  label,
  paymentMethod,
  propertyTicker,
  updateFormValue,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const config = useConfig();
  const { createConnectedAccount } = useStripePaymentsApi(
    config.paymentsApiEndpoint,
    propertyTicker
  );

  async function onClick() {
    try {
      setLoading(true);
      const account = await createConnectedAccount(paymentMethod);

      updateFormValue({
        action: UPDATE_ENTITY_ACTIONS.REPLACE,
        formValueProperties: "accountId",
        value: account.accountId,
      });

      updateFormValue({
        action: UPDATE_ENTITY_ACTIONS.REPLACE,
        formValueProperties: "accountLink",
        value: account.accountLink,
      });

      updateFormValue({
        action: UPDATE_ENTITY_ACTIONS.REPLACE,
        formValueProperties: "accountLinkExpiresAt",
        value: String(account.accountLinkExpiresAt),
      });
      setError(false);
    } catch (e) {
      console.error("Some error creating connected account:", e);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container>
      <Button className="w-fi" disabled={loading} onClick={onClick}>
        <ButtonContainer>
          {label}
          {loading && <StyledSpinner className="fa fa-spinner fa-spin" />}
        </ButtonContainer>
      </Button>
      {error && (
        <span className="text-red-500">
          <FormattedMessage {...messages.error} />
        </span>
      )}
    </Container>
  );
}
